import { useMemo } from "react";
import { Inference } from "../../../types/inferences";
import { addSpeciesCount, addSpeciesValidatedCount, groupByModelRun, GroupCounts, InferenceCounts, inferenceStatsPerGroup } from "../../../utils/inferenceStats";

function useInferenceSummary(inferences: Inference[] = []): InferenceCounts & {modelRuns: GroupCounts} {
  return useMemo(() => {
    const inferencesByModelRun = groupByModelRun(inferences);
    const modelRunSummary = inferenceStatsPerGroup(inferencesByModelRun);

    const sceneStats = Object.values(modelRunSummary).reduce((summary, modelRun) => {
      const { validated, species, speciesValidated } = modelRun;
      return {
        ...summary,
        validated: summary.validated + validated,
        species: addSpeciesCount(summary.species, species),
        speciesValidated: addSpeciesValidatedCount(summary.speciesValidated, speciesValidated)
      };
    }, {
      count: inferences.length,
      validated: 0,
      species: {},
      speciesValidated: {}
    });

    return { ...sceneStats, modelRuns: modelRunSummary };
  }, [inferences]);
}

export default useInferenceSummary;
